import { ReactComponent as USAPatientSrc } from "assets/images/shapes/patient-usa.svg";
import { ReactComponent as SubscriptionFreeIconSrc } from "assets/images/shapes/subscription-free-icon.svg";
import { Fragment } from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import SocialShareNav from "views/components/SocialShareNav";
import MetaTags from "views/sections/MetaTags";
import RootFooter from "views/sections/RootFooter";
import RootHeader from "views/sections/RootHeader";
import RootMain from "views/sections/RootMain";
import RootScrollToBottom from "views/sections/RootScrollToBottom";
import RootScrollToTop from "views/sections/RootScrollToTop";

const PublicLayout = ({
	children,
	pageTitle = "",
	type = "",
	bg = "",
	allowHeaderContent,
	allowHeaderActions,
	isHeaderSticky,
	isHeaderFixed,
	allowFloatingPatientPending,
	allowFloatingSocialShare,
}) => {
	const Wrapper = ["home", "webinar", "careers", "static"].includes(type) ? ParallaxProvider : Fragment;

	const isOpenedInIframe = window.location !== window.parent.location;

	return (
		<Wrapper>
			<MetaTags pageTitle={pageTitle} />
			<div className={`${bg} ${type ? `page-${type}` : ""} d-flex flex-column align-items-stretch min-vh-100`}>
				<RootHeader
					type={type}
					allowHeaderContent={allowHeaderContent}
					allowHeaderActions={allowHeaderActions}
					isHeaderSticky={isHeaderSticky}
					isHeaderFixed={isHeaderFixed}
				/>
				<RootMain
					className={`position-relative ${
						["patient", "entry", "patient-intake", "demo", "newsletter"]?.includes(type) &&
						!isOpenedInIframe
							? "bg-primary-300"
							: ""
					} ${!["demo-single-note"]?.includes(type) ? "overflow-hidden " : ""}`}>
					{["home"]?.includes(type) && allowFloatingPatientPending ? (
						<>
							<div className="root-patent-pending ms-n2 position-absolute start-0 end-initial overflow-hidden">
								<div className="position-relative">
									<USAPatientSrc />
								</div>
							</div>
							<div className="root-subscription-free-icon position-absolute end-0 start-initial overflow-hidden">
								<div className="position-relative">
									<SubscriptionFreeIconSrc />
								</div>
							</div>
						</>
					) : (
						<></>
					)}
					{allowFloatingSocialShare && (
						<div className="floating-social-share fixed-top w-fit-content end-0 start-initial top-50 translate-middle-y">
							<SocialShareNav />
						</div>
					)}
					{children}
				</RootMain>
				{[
					"home",
					"webinar",
					"auth",
					"careers",
					"static",
					"patient",
					"patient-intake",
					"demo",
					"demo-single-note",
					"entry",
					"newsletter",
				]?.includes(type) &&
					!isOpenedInIframe && <RootFooter type={type} />}
				{type !== "webinar" && <RootScrollToTop />}
				{["patient"]?.includes(type) && <RootScrollToBottom />}
			</div>
		</Wrapper>
	);
};

export default PublicLayout;
